import { RootState } from "..";
import { SliceStatus } from "../utils";
import { areasAdapter } from "./areasSlice";

export const selectAreasLoading = (state: RootState) =>
  state.areas.status === SliceStatus.LOADING;

export const selectAreasState = (state: RootState) => state.areas;

const { selectById, selectAll } = areasAdapter.getSelectors(selectAreasState);

export const selectAllAreas = selectAll;

export const selectAreaById = (id: number | string) => (state: RootState) =>
  selectById(state, id);
